// extracted by mini-css-extract-plugin
export default {"branchDetails":"BranchCard_branchDetails__E3wYB","button":"BranchCard_button__+AlLe"};